// agents/src/components/LanguageSwitcher.jsx
import { useTranslation } from 'react-i18next';
import { getCurrentMarket, AVAILABLE_LANGUAGES } from '../config/markets';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const market = getCurrentMarket();
  const currentLanguage = i18n.language;

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
  };

  // Filtrar idiomas: idioma nativo del mercado + inglés
  const availableLanguages = AVAILABLE_LANGUAGES.filter(
    lang => lang.code === market.nativeLanguage || lang.code === 'en'
  );

  return (
    <div style={styles.container}>
      {availableLanguages.map(lang => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          style={{
            ...styles.button,
            ...(currentLanguage === lang.code ? styles.activeButton : {})
          }}
          title={lang.name}
        >
          <span dangerouslySetInnerHTML={{
              __html: lang.icon,
            }}></span>
        </button>
      ))}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center'
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.4rem',
    border: '2px solid #ddd',
    borderRadius: '50%',
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s',
    width: '40px',
    height: '40px',
    ':hover': {
      backgroundColor: '#f5f5f5',
      transform: 'scale(1.05)'
    }
  },
  activeButton: {
    borderColor: '#423ef4',
    boxShadow: '0 0 8px rgba(24, 144, 255, 0.4)'
  },
  icon: {
    width: '28px',
    height: '28px',
    objectFit: 'cover',
    borderRadius: '50%'
  },
  flag: {
    fontSize: '1.5rem'
  }
};
